var routes = []
var secondaryRoutes = []
var standaloneRoutes = []
var apoOneRoutes = []

const requireContext = require.context('.', false, /.(core|apo_one)\.(js)$/)
requireContext.keys().forEach(file => {
  const routesFile = requireContext(file)

  if ('default' in routesFile) {
    if (file === './apo_one.js') {
      apoOneRoutes = apoOneRoutes.concat(routesFile.default)
    } else {
      routes = routes.concat(routesFile.default)
    }
  }
})

export default {routes, secondaryRoutes, standaloneRoutes, apoOneRoutes}
